import { authPost } from "@api";
import { DEPLOYMENT_URL } from "@constants";
import { DeploymentReposRefreshResponse } from "@types";

export const refreshDeploymentRepos = (
  deploymentId: string
): Promise<DeploymentReposRefreshResponse> => {
  let url = `${DEPLOYMENT_URL}/${deploymentId}/repos/_refresh`;
  return authPost<{}, DeploymentReposRefreshResponse>(url, {});
};
